"use client";

import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AddToCartButton, EcommerceProductsProvider, useEcommerceProducts } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
const wp_query_params = {
  per_page: 12
};
const wp_query = new WP_Query(wp_query_params);
function ProductsGridConsumer() {
  const {
    products,
    loading,
    error,
    hasNext,
    loadMore,
    isRefetching,
    refetch
  } = useEcommerceProducts();
  const [activeTab, setActiveTab] = React.useState("tous");
  const displayedProducts = React.useMemo(() => {
    if (!products) return [];
    if (activeTab === "tous") return products;
    return products.filter(p => {
      const inCategory = p.categories?.some(c => c.name.toLowerCase().includes(activeTab.toLowerCase()));
      const inTitle = p.title.toLowerCase().includes(activeTab.toLowerCase());
      return inCategory || inTitle;
    });
  }, [products, activeTab]);
  if (error) {
    return <div className="flex flex-col items-center justify-center py-12 text-center">
        <p className="text-destructive mb-4">
          Impossible de charger les capsules pour le moment.
        </p>
        <Button onClick={refetch} variant="outline">
          Réessayer
        </Button>
      </div>;
  }
  return <div className="flex flex-col gap-8">
      {}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <Tabs defaultValue="tous" onValueChange={setActiveTab} className="w-full sm:w-auto">
          <TabsList className="grid w-full grid-cols-3 sm:w-auto sm:flex">
            <TabsTrigger value="tous">Tous</TabsTrigger>
            <TabsTrigger value="dolce">Dolce Gusto</TabsTrigger>
            <TabsTrigger value="tassimo">Tassimo</TabsTrigger>
          </TabsList>
        </Tabs>

        <Select defaultValue="intensite">
          <SelectTrigger className="w-full sm:w-[200px]">
            <SelectValue placeholder="Filtrer par" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="intensite">Intensité</SelectItem>
            <SelectItem value="saveur">Saveur</SelectItem>
            <SelectItem value="nouveaute">Nouveautés</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {}
      {loading && products.length === 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-[350px] rounded-xl bg-muted/50 animate-pulse" />)}
        </div> : displayedProducts.length === 0 ? <div className="py-12 text-center text-muted-foreground">
          Aucune capsule trouvée pour cette sélection.
        </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {displayedProducts.map((product, i) => <Link key={product.id} to={product.link} data-index={i} className="flex flex-col no-underline">
              <article className="group flex flex-col h-full bg-card rounded-2xl overflow-hidden border border-border shadow-sm hover:shadow-md transition-all duration-300">
                <div className="relative aspect-square bg-muted overflow-hidden">
                  {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-secondary/50">
                      <span className="text-muted-foreground text-sm">
                        Image non disponible
                      </span>
                    </div>}
                </div>

                <div className="p-5 flex flex-col flex-grow">
                  <h3 className="font-semibold text-lg text-foreground mb-2 line-clamp-2 group-hover:text-primary transition-colors">
                    {product.title}
                  </h3>

                  {product.short_description && <div className="text-sm text-muted-foreground mb-4 line-clamp-2 [&>p]:mb-0" dangerouslySetInnerHTML={{
              __html: product.short_description
            }} />}

                  <div className="mt-auto pt-4 flex flex-col gap-4">
                    {product.price !== undefined && <div className="flex items-center gap-2">
                        <div className="text-xl font-bold text-foreground">
                          {product.price.toLocaleString("fr-SN", {
                    style: "currency",
                    currency: "XOF",
                    minimumFractionDigits: 0
                  })}
                        </div>
                      </div>}

                    <div onClick={e => e.stopPropagation()}>
                      <AddToCartButton productId={product.id} className="w-full" buttonClassName="bg-primary text-primary-foreground w-full hover:bg-primary/90" text="Ajouter au panier" showQuantity={false} />
                    </div>
                  </div>
                </div>
              </article>
            </Link>)}
        </div>}

      {}
      {hasNext && <div className="flex justify-center mt-8">
          <Button onClick={async () => await loadMore()} disabled={isRefetching} variant="outline" size="lg" className="min-w-[200px]">
            {isRefetching ? "Chargement..." : "Voir plus de capsules"}
          </Button>
        </div>}
    </div>;
}
export default function NosGammesDeCapsules() {
  return;
}